import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";

export const getPromotedByString = (
  promotedBy: ILeanProductTile.ILeanProduct["promoted_by"] | undefined
): string => {
  return promotedBy?.join(" ") ?? "";
};
